import React, { useContext, useEffect, useState } from "react";
import Header from "parts/Header";
import Footer from "parts/Footer";
import ServiceTab from "parts/ServiceTab"; // Ensure the path is correct
import HeroService from "parts/HeroService";
import { Services } from "json/landingPageData"; // Import your static data
import { ServicesContext } from "context/ServiceContext"; // Import your context
import Load from "parts/Load";
import { Helmet } from "react-helmet-async";

const ServicePage = () => {
  const { services, loading, error } = useContext(ServicesContext);
  const [data, setData] = useState([]); // State to hold the services data

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (loading) return; // Skip if loading
    if (error) {
      setData(Services); // Use static data when there's an error
    } else {
      setData(services.data); // Use API data when available
    }
  }, [loading, error, services]);

  // If still loading, show loading message
  if (loading) return <Load />;

  return (
    <>
      {/* SEO  */}
      <Helmet>
        <title>Scode Software Solutions</title>
        <meta
          name="description"
          content="Empowering your vision with cutting-edge development solutions that
          deliver impactful, user-focused digital experiences across web, mobile,
          and beyond."
        />
        <link rel="canonical" href="https://www.scodesoft.com/services" />
      </Helmet>
      <Header />
      <HeroService />
      <ServiceTab data={data} /> {/* Pass the determined data */}
      <Footer />
    </>
  );
};

export default ServicePage;
